export function getDateArr(days) {
  const today = new Date();

  const daysData: any = [];

  for (let i = 3; i < days; i++) {
    const day = i * 24 * 60 * 60 * 1000;

    const todayTimeStamp = today.getTime();

    const finalDay = new Date(todayTimeStamp + day);

    let M: any = finalDay.getMonth() + 1;

    let D: any = finalDay.getDate();
    let W: any = finalDay.getDay();

    let b = '';
    switch (W) {
      case 0:
        b = '日';
        break;
      case 1:
        b = '一';
        break;
      case 2:
        b = '二';
        break;
      case 3:
        b = '三';
        break;
      case 4:
        b = '四';
        break;
      case 5:
        b = '五';
        break;
      default:
        b = '六';
    }
    if (M.toString().length == 1) {
      M = '0' + M;
    }
    if (D.toString().length == 1) {
      D = '0' + D;
    }
    const timeData = M + '月' + D + '日' + ' ' + '周' + b;
    daysData.push({ text: timeData, value: finalDay.getTime() });
  }
  return daysData;
}
